/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../ui/button';
import Loading from '../Loading';

class Step4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { foo: 'bar' };
  }

  render() {
    console.log('response', this.props.response);
    return (
      <div>
        {this.props.response == null ? (
          <p className="mb-2">Select an action on the notification</p>
        ) : null}
        <div>
          {this.props.responseLoading ? (
            <Loading />
          ) : this.props.response ? (
            <div>
              <p className="mb-2">Response: {this.props.response}</p>
              <div>
                <p className="mb-2">You're all setup!</p>
                <Button asChild>
                  <Link to="/">Go to account</Link>
                </Button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Step4;
